let current_tab = null

document.addEventListener('DOMContentLoaded', function() {
    FiltersInit()
    if(checkSelector('.CollectionContentTabs')) {
      CollectionTabs()
      StockFilter()
    }

    if(checkSelector('#Filters')) {
      let Filters = document.querySelector('#Filters')
      let Submit = document.querySelector('#showResults')
      let FiltersState = document.querySelector('[data-state-filters]')
      let FiltersCount = document.querySelector('#fabric-count')
      let ResetFilter = document.querySelector('#clearFilter')
 
      ResetFilter.addEventListener('click', (e) => {
        Filters.reset()
        const forma = new URLSearchParams(new FormData(Filters))
        e.preventDefault()

        fetch("?" + forma, {method: "GET"})
        .then(data => data.text()).then(html => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, 'text/html');
  
          let productList = doc.querySelector('#product-list')
          if(productList) {
            document.querySelector('#product-list').remove()
            document.querySelector('.all-fabric-content').appendChild(productList)
            document.querySelectorAll('[collection-product]').forEach((elem)=>CollectionProduct(elem));
            FiltersCount.innerText = document.querySelectorAll('[collection-product]').length
          }
        })
      })
  
      Submit.addEventListener('click', (e) => {
        let forma = new URLSearchParams(new FormData(Filters))
        e.preventDefault()
  
        fetch("?" + forma, {method: "GET"})
        .then(data => data.text()).then(html => {
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, 'text/html');
  
          let productList = doc.querySelector('#product-list')
          if(productList) {
            FiltersState.dataset.stateFilters = 0
            document.querySelector('#product-list').remove()
            document.querySelector('.all-fabric-content').appendChild(productList)
            document.querySelectorAll('[collection-product]').forEach((elem)=>CollectionProduct(elem));
            FiltersCount.innerText = document.querySelectorAll('[collection-product]').length
          }
        })
      })
    }
    
})

function CollectionTabs() {
  const tabButtons = document.querySelectorAll(".CollectionContentTabsButton")
  const tabsWrap = document.querySelector(".CollectionContentTabsWrap")

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      tabButtons.forEach((btn) => btn.classList.remove("active"))
      this.classList.add("active")
      const currentTab = this.getAttribute("data-collection-tab-handle") || "All";
      tabsWrap.setAttribute("data-current-tab", currentTab)
      
      document.dispatchEvent(new CustomEvent("tabchange", {
        detail: { tab: currentTab },
      }))
    })
  })
}


function StockFilter() {
  document.addEventListener('tabchange', (e) => {
    const currentTab = e.detail.tab
    const localPath = window.location.pathname

    if(currentTab == 'All') {
      fetchFilter(localPath)
    } else {
      fetchFilter(localPath + "/" + FirstLetter(currentTab))
    }
  })
}

function pFilter(search) {
  if(!search) {
    fetchFilter()
  } else {
    fetchFilter(new URLSearchParams(search))
  }
}

function FirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function fetchFilter(url, data) {
  if(!data) data = " "
  if(!url) url = " "
  fetch(url + "?" + data, {method: "GET"})
      .then(data => data.text()).then(html => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');

        let productList = doc.querySelector('#product-list')
        if(productList) {
          document.querySelector('#product-list').remove()
          document.querySelector('.all-fabric-content').appendChild(productList)
          document.querySelectorAll('[collection-product]').forEach((elem)=>CollectionProduct(elem));
        }
  })
}

function FiltersInit() {
  if(!checkSelector('[filter-button]')) return 0
  const FilterButton = document.querySelector('[filter-button]')
  const FiltersState = { object: document.querySelector('[data-state-filters]'), state: 0 }
  const FilterCloseButton = document.querySelector('.close')
  const FilterMenu = document.querySelector('.Fltr')
  const zindex = document.querySelector('.all-fabrics')

  FilterButton.addEventListener('click', (e) =>  { 
    if(FiltersState.state && FiltersState.object.dataset.stateFilters == 0) {
      zindex.setAttribute('style', ' ')
      FiltersState.state = 0
      FilterMenu.classList.remove('active')
    }
    if(FiltersState.state) {
      if(e.target.classList.contains('Fltr') || e.target.closest('.Fltr') && !e.target.closest('.close')) return 0
      if(e.target.closest('.close')) return 0
      FilterMenu.classList.remove('active')
      wait(100).then(() => {
        zindex.setAttribute('style', ' ')
        FiltersState.object.dataset.stateFilters = 0
        FiltersState.state = 0
      })
    } else {
      zindex.setAttribute('style', 'z-index: 11;')
      FiltersState.object.dataset.stateFilters = 1
      FiltersState.state = 1
      wait(100).then(() => {
        FilterMenu.classList.add('active')
      })
    }
    
  })

  FilterCloseButton.addEventListener('click', (e) => {
      e.stopPropagation()
      FilterMenu.classList.remove('active')
      wait(100).then(() => {
        zindex.setAttribute('style', ' ')
        FiltersState.object.dataset.stateFilters = 0
        FiltersState.state = 0
      })
  })
}

async function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}